import { required } from 'vuelidate/lib/validators';

const validations = {
  title: {
    required,
  },
  contentTitle: {
    required,
  },
};

export default validations;
